/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

export const getReviewSubmitReviewLoading = review =>
  review && review.submitReviewLoading ? review.submitReviewLoading : false;
export const getReviewSubmitReviewStatus = review =>
  review && review.submitReviewStatus ? review.submitReviewStatus : false;

// review item
export const getReviewID = review => (review && review.id ? review.id : null);
export const getReviewUserName = review =>
  review && review.user && review.user.name ? review.user.name : null;
export const getReviewStatusCode = review =>
  review && review.status && review.status.code ? review.status.code : null;
export const getReviewStatusName = review =>
  review && review.status && review.status.name ? review.status.name : null;
export const getReviewRating = review =>
  review && review.rating ? review.rating : 0;
export const getReviewComment = review =>
  review && review.comment ? review.comment : null;
export const getReviewAttributeIsSummittable = review =>
  review && review.attribute && review.attribute.is_submittable
    ? review.attribute.is_submittable
    : false;
export const getReviewCreatedTimeValue = review =>
  review && review.created_datetime && review.created_datetime.value
    ? review.created_datetime.value
    : null;
export const getReviewCreatedTimeTimestamp = review =>
  review && review.created_datetime && review.created_datetime.timestamp
    ? review.created_datetime.timestamp
    : null;
export const getReviewRelativeTime = review =>
  review && review.created_datetime && review.created_datetime.relative
    ? review.created_datetime.relative
    : null;



// WEBPACK FOOTER //
// ./src/selectors/review.js